/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderResource } from './orderResource';


export interface OrderList200Response { 
    data: Array<OrderResource>;
    countOrders: number;
}

